export default {
  methods: {
    updateBrowserTitle (title) {
      document.title = 'veroFresh - ' + title
    }
  }
}
